import { render, staticRenderFns } from "./SectionDescriptionDocuments.vue?vue&type=template&id=514da3fb&"
import script from "./SectionDescriptionDocuments.vue?vue&type=script&lang=js&"
export * from "./SectionDescriptionDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SectionDescriptionDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports